export const shortCircuitEvent = (e) => {
  e?.preventDefault();
  e?.stopPropagation();
};
